import { useTranslation } from '@/i18n';
import { Heading } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, ReactNode } from 'react';
import styles from '../../index.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  children: ReactNode;
};

export const WithdrawalLayout: FC<Props> = memo(({ children }) => {
  const { t } = useTranslation();
  return (
    <div className={cx(styles['office-withdrawal-container'])}>
      <Heading as='h3' size='20px' className={cx(styles['heading'])}>
        {t('office_withdrawal.check_before_leave')}
      </Heading>
      <div className={cx(styles['office-withdrawal-form-container'])}>
        {children}
      </div>
    </div>
  );
});
WithdrawalLayout.displayName = 'WithdrawalLayout';
